<template>
	<v-flex xs12>
		
		<v-container>
			<Upload
				button-text="Upload a video file"
				:instruction-text="`You can upload 1 video (${validExtensions}) file`"
				:max-files="1"
				validate-method="checkpointsValidator/validateVideoTask"></Upload>
		</v-container>
		<v-container>
			<VideoAnswers

				v-if="taskType == 7 || taskType == 17"></VideoAnswers>
			<v-card-actions>
			        	<!--v-btn flat :disabled="!valid" @click="store()" small color="success">
			        		<v-icon>save</v-icon>
			        		{{translater.__('Save')}}
			        	</v-btn-->
						<SuccessButton :valid="valid" :onClick="store"></SuccessButton>
			        	<!--v-btn flat @click="add = false" small color="error">
			        		<v-icon>cancel</v-icon>
			        		{{translater.__('Cancel')}}
			        	</v-btn-->
						<ErrorButton :onClick="() => add = false"></ErrorButton>
			        </v-card-actions>
		</v-container>
	</v-flex>
</template>

<script>
	import Upload from './Upload'
	import VideoAnswers from './VideoAnswers'
	import fileTools from '../../../tools/files';
	import SuccessButton from '../../../common/components/SuccessButton'
	import ErrorButton from '../../../common/components/ErrorButton'

	export default {
		name: 'VideoTask',
		components: {
			Upload,
			VideoAnswers,
			ErrorButton,
			SuccessButton
		},

		methods: {
			store()
			{
				this.$store.dispatch('checkpoints/storeVideoTask');
			}
		},

		computed: {

			validExtensions: {
				get()
				{
					const {validExtensions} = fileTools.getValidExtensions(this.taskType,
							this.$store.getters['files/validMimeTypes'])

					return validExtensions.join(', ')
				}
			},

			taskType: {
				get()
				{
					return this.$store.getters['checkpoints/newTask'].type
				},

				/*set(value)
				{
					this.$store.dispatch('checkpoints/setNewTaskType', value)
				}*/
			},

			valid: {
				get()
				{
					return this.$store.getters['checkpointsValidator/isValid'];
				}
			},

			translater: {
				get()
				{
					return this.$store.getters['translate/translater'];
				}
			},

			add: {
				get()
				{
					return this.$store.getters['checkpoints/add']
				},

				set(value)
				{
					this.$store.dispatch('checkpoints/setAddCheckpoint', value)
				}

			},
		}
	}
</script>